import cn from "@/v2-ui/utils/utils.cn"
import Badge from "@/v2-backoffice-client/components/badge"
import Button from "@/v2-backoffice-client/components/button"
import { presetLabel } from "@/v2-backoffice-client/tenant/privacy/tenant.privacy.utils"
import type { PrivacyPreset } from "@/v2-backoffice-client/tenant/privacy/tenant.privacy.types"

export type TenantPrivacyPresetCardsProps = {
  presets: PrivacyPreset[]
  /** The preset the team's effective policy matches; null when custom. */
  matchesPresetCode: number | null | undefined
  isBusy: boolean
  onApply(preset: PrivacyPreset): void
}

// The quick choices. The active card is marked once — border + tint, the
// app's selected-card treatment — and offers no action; the others offer
// Apply, which opens the confirm dialog.
function TenantPrivacyPresetCards(props: TenantPrivacyPresetCardsProps) {
  const { presets, matchesPresetCode, isBusy, onApply } = props

  return (
    <section className="flex flex-col gap-2">
      <h3 className="text-sm font-semibold">Quick choices</h3>

      <div className="grid gap-3 sm:grid-cols-3">
        {presets.map((preset) => {
          const isActive = preset.Code === matchesPresetCode

          return (
            <section
              key={preset.Code}
              className={cn(
                "flex flex-col gap-2 rounded-md border p-3",
                isActive && "border-primary bg-primary/5",
              )}
            >
              <div className="flex flex-wrap items-center gap-2">
                <h4 className="text-sm font-medium">{presetLabel(preset)}</h4>
                {preset.IsRecommended && (
                  <Badge size="tiny" variant="positive">
                    Recommended
                  </Badge>
                )}

                <div className="flex-1" />

                {!isActive && (
                  <Button
                    type="button"
                    size="xs"
                    variant="outline"
                    disabled={isBusy}
                    data-feature-code="UI_BackofficeTenantPrivacy_Preset_Apply"
                    onClick={() => {
                      onApply(preset)
                    }}
                  >
                    Apply
                  </Button>
                )}
              </div>

              <p className="text-xs text-muted-foreground">
                {preset.Description}
              </p>
            </section>
          )
        })}
      </div>
    </section>
  )
}

export default TenantPrivacyPresetCards
